import { css } from '@emotion/css';

const styles = {
  container: css`
    position: relative;
    width: 100%;
    aspect-ratio: 8.5 / 11;
  `,
  image: css`
    display: block;
    width: 100%;
    aspect-ratio: 8.5 / 11;
  `,
  dimmed: css`
    opacity: 0.2;
  `,
  overlay: css`
    position: absolute;
    left: 0;
    top: 0;
  `,
  link: css`
    position: absolute;
    cursor: pointer;
  `,
  flyerOpacity: css`
    opacity: 0.3;
  `,
};

export default styles;
